<template>
    <div>
     <!-- <v-row v-if="diasRestantes <= 60">
            <v-col sm="12" md="12" lg="12">
                <v-card color="#FFB12C">
                    <v-card-title>
                        Aviso de expiración de certificado.
                    </v-card-title>
                    <v-card-text>
                        Su certificado digital entró en alerta de expiración,
                        tiene <strong>{{diasRestantes}}</strong> días de vigencia.
                        Fecha de expiración: <strong>{{fechaExpiracionCertificado}}</strong>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
        <div>
          <v-row>
            <v-col sm="12" md="6" xs="12" lg="3" cols="12">
              <v-col sm="12" md="12" xs="12" cols="12">
                  <v-card elevation="2" outlined>
                    <v-card-title>
                          <v-icon small color="black">fas fa-city</v-icon>
                          <div style="margin-left:10px">Empresas</div>
                      </v-card-title>
                      <v-card-text class="text-center text--primary">
                        <v-row class="line-slim">
                          <v-col sm="8" md="8" style="text-align: right;">
                            Empresas:
                          </v-col>
                          <v-col sm="4" md="4" style="text-align: left;">
                            <span class="yellow darken-3" dark
                              style="color:white; padding: 4px; border-radius: 5px">{{cant_empresas}}
                            </span>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-title>
                          <v-icon small color="black">fas fa-user</v-icon>
                          <div style="margin-left:10px">Usuarios</div>
                      </v-card-title>
                      <v-card-text class="text-center text--primary">
                        <v-row class="line-slim"  v-if="admin">
                          <v-col sm="8" md="8" style="text-align: right;">
                            Administrador:
                          </v-col>
                          <v-col sm="4" md="4" style="text-align: left;">
                            <span class="success"
                              style="color:white; padding: 4px; border-radius: 5px"
                            >
                              {{cant_usuarios.admin}}
                            </span>
                          </v-col>
                        </v-row>
                        <v-row class="line-slim">
                          <v-col sm="8" md="8" style="text-align: right;">
                            Seniat:
                          </v-col>
                          <v-col sm="14" md="4" style="text-align: left;">
                            <span class="cyan darken-1"
                              style="color:white; padding: 4px; border-radius: 5px"
                            >
                              {{cant_usuarios.seniat}}
                            </span>
                          </v-col>
                        </v-row>
                        <v-row class="line-slim"  v-if="admin">
                          <v-col sm="8" md="8" style="text-align: right;">
                            Imprenta:
                          </v-col>
                          <v-col sm="4" md="4" style="text-align: left;">
                            <span class="red accent-3"
                              style="color:white; padding: 4px; border-radius: 5px"
                            >
                              {{cant_usuarios.imprenta}}
                            </span>
                          </v-col>
                        </v-row>
                      </v-card-text>
                  </v-card>
              </v-col>
            </v-col>
            <v-col sm="12" md="6" xs="12" lg="3" cols="12">
                <v-card elevation="2" outlined>
                    <v-card-title>
                        <v-icon small color="black">fas fa-file</v-icon>
                        <div style="margin-left:10px">Documentos</div>
                    </v-card-title>
                    <v-card-text class="text-center text--primary">
                      <v-row class="line-slim">
                        <v-col sm="6" md="6" style="text-align: right;">
                          Facturas:
                        </v-col>
                        <v-col sm="6" md="6" style="text-align: left;">
                          <span class="blue darken-1"
                            style="color:white; padding: 4px; border-radius: 5px"
                          >
                            {{cant_documentos.facturas}}
                          </span>
                        </v-col>
                      </v-row>
                      <v-row class="line-slim">
                        <v-col sm="6" md="6" style="text-align: right;">
                          Notas de Crédito:
                        </v-col>
                        <v-col sm="6" md="6" style="text-align: left;">
                          <span class="blue darken-1"
                            style="color:white; padding: 4px; border-radius: 5px"
                          >
                            {{cant_documentos.credito}}
                          </span>
                        </v-col>
                      </v-row>
                      <v-row class="line-slim">
                        <v-col sm="6" md="6" style="text-align: right;">
                          Notas de Débito:
                        </v-col>
                        <v-col sm="6" md="6" style="text-align: left;">
                          <span class="blue darken-1"
                            style="color:white; padding: 4px; border-radius: 5px"
                          >
                            {{cant_documentos.debito}}
                          </span>
                        </v-col>
                      </v-row>
                      <v-row class="line-slim">
                        <v-col sm="6" md="6" style="text-align: right;">
                          Guías de Despacho:
                        </v-col>
                        <v-col sm="6" md="6" style="text-align: left;">
                          <span class="blue darken-1"
                            style="color:white; padding: 4px; border-radius: 5px"
                          >
                            {{cant_documentos.guias}}
                          </span>
                        </v-col>
                      </v-row>
                      <v-row class="line-slim">
                        <v-col sm="6" md="6" style="text-align: right;">
                          Retenciones:
                        </v-col>
                        <v-col sm="6" md="6" style="text-align: left;">
                          <span class="blue darken-1"
                            style="color:white; padding: 4px; border-radius: 5px"
                          >
                            {{cant_documentos.retenciones}}
                          </span>
                        </v-col>
                      </v-row>
                      <v-row class="line-slim">
                        <v-col sm="6" md="6" style="text-align: right;">
                          <b>TOTAL:</b>
                        </v-col>
                        <v-col sm="6" md="6" style="text-align: left;">
                          <span class="success"
                            style="color:white; padding: 4px; border-radius: 5px"
                          >
                            {{cant_documentos.total}}
                          </span>
                        </v-col>
                      </v-row>
                      <br>
                      <v-row class="line-slim">
                        <v-col sm="6" md="6" style="text-align: right;">
                          Anulaciones:
                        </v-col>
                        <v-col sm="4" md="4" style="text-align: left;">
                          <span class="red"
                            style="color:white; padding: 4px; border-radius: 5px"
                          >
                            {{cant_documentos.anulados}}
                          </span>
                        </v-col>
                      </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col sm="12" md="12" xs="12" lg="6" cols="12">
                <v-row>
                    <v-col sm="4" xs="12">
                        <v-select
                            :items="dias"
                            :menu-props="{ top: false, offsetY: true }"
                            label="Días"
                            v-model="defaultDaySelected.value"
                            @change="changeDias"
                        ></v-select>
                    </v-col>
                    <v-col sm="4" xs="12">
                        <v-select
                            :items="meses"
                            :menu-props="{ top: false, offsetY: true }"
                            label="Meses"
                            v-model="defaultMonthSelected.value"
                            @change="changeMeses"
                        ></v-select>
                    </v-col>
                    <v-col sm="4" xs="12">
                        <v-select
                            :items="años"
                            :menu-props="{ top: false, offsetY: true }"
                            label="Años"
                            v-model="defaultYearSelected.value"
                            @change="changeAnios"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col sm="12">
                      <vuetify-select :indicator="true" />
                    </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12">
                    <v-col
                      v-if="downloading"
                      class="subtitle-1 text-center"
                      cols="12"
                    > Cargando por favor espere...
                    </v-col>
                    <v-progress-linear
                      indeterminate
                      :background-color="backgroundLoadingColor"
                      :color="loadingColor"
                      height="10"
                      v-if="downloading"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
                <v-row>
                    <v-col sm="12" style="height: 200px">
                        <bar-chart :data="dataBarChart" :colors="new Array(graphicColor)"></bar-chart>
                    </v-col>
                </v-row>
            </v-col>
          </v-row>
          <v-row style="margin-top: 150px">
              <v-col sm="12" md="12" xs="12">
                  <line-chart :data="dataLineChart" />
              </v-col>
          </v-row>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import VuetifySelect from '~/components/VuetifySelect';

export default {
    middleware: 'auth',

    metaInfo() {
      return { title: this.$t('home') };
    },
    components: {
      VuetifySelect,
    },
    data() {
        return {
            date: `${moment(new Date()).format('YYYY-MM').toString()}-all`,
            dias: [
                { text: 'Todos', value: 'all' },
            ],
            defaultDaySelected: { text: 'Todos', value: 'all' },
            mesesTotales: [
                { text: 'Todos', value: 'all' }, { text: 'Enero', value: '01' }, { text: 'Febrero', value: '02' }, { text: 'Marzo', value: '03' },
                { text: 'Abril', value: '04' }, { text: 'Mayo', value: '05' }, { text: 'Junio', value: '06' },
                { text: 'Julio', value: '07' }, { text: 'Agosto', value: '08' }, { text: 'Septiembre', value: '09' },
                { text: 'Octubre', value: '10' }, { text: 'Noviembre', value: '11' }, { text: 'Diciembre', value: '12' },
            ],
            meses: [],
            defaultMonthSelected: { text: moment(new Date()).format('MMMM').toString(), value: moment(new Date()).format('MM').toString() },
            defaultYearSelected: { text: moment(new Date()).format('YYYY'), value: parseInt(moment(new Date()).format('YYYY'), 10) },
            años: [],
            nombre_licencia: '',
            no_folios_totales: 0,
            duracion_total: 0,
            codigo_licencia: '-',
            cadencia: 0,
            fecha_inicio: '-',
            fecha_fin: '-',
            no_etapa: 0,
            no_folios_ciclo: 0,
            no_folios_ciclo_utilizados: 0,
            no_folios_ciclo_disponibles: 0,
            fecha_inicio_ciclo: '-',
            fecha_fin_ciclo: '-',
            total_disponibles: 0,
            total_utilizados: 0,
            dataBarChart: [
                ['Facturas', 0],
                ['Notas de Crédito', 0],
                ['Notas de Débito', 0],
                ['Guías de Despacho', 0],
                ['Comprobantes de Retención IVA', 0],
                ['Comprobantes de Retención ISLR', 0],
                ['Anulados', 0],
            ],
            dataLineChart: [
                { name: 'Ventas', data: [] },
                { name: 'Impuestos', data: [] },
                { name: 'Total', data: [] },
            ],
            diasRestantes: 999,
            fechaExpiracionCertificado: '',
            downloading: false,
            cant_usuarios: {
              admin: 0,
              seniat: 0,
              imprenta: 0,
            },
            cant_numeraciones: 0,
            cant_lotes: 0,
            cant_empresas: 0,
            admin: false,
            cant_documentos: {
              facturas: 0,
              credito: 0,
              debito: 0,
              guias: 0,
              retenciones: 0,
              total: 0,
              anulados: 0,
            },
        };
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
        taxpayer_id: 'taxpayer/id',
        loadingColor: 'theme/loadingColor',
        backgroundLoadingColor: 'theme/backgroundLoadingColor',
        graphicColor: 'theme/graphicColor',
      }),
    },
    watch: {
      taxpayer_id: {
        handler() {
          this.actualizar();
        },
        deep: true,
      },
    },
    mounted() {
        this.admin = this.user.role === 1 || this.user.role === 2;
        moment.locale('es');
        for (let i = 2022; i <= parseInt(moment(new Date()).format('YYYY'), 10); i++) {
            this.años.push(i);
        }
        for (let i = 0; i <= parseInt(moment(new Date()).format('M'), 10); i++) {
            this.meses.push(this.mesesTotales[i]);
        }
        this.actualizar();
        this.getIndicadores();
    },
    methods: {
        changeDias(dia) {
            const splitDate = this.date.split('-');
            this.date = `${splitDate[0]}-${splitDate[1]}-${dia}`;
            this.actualizarIndicadoresDocumentos(dia, splitDate[1], splitDate[0]);
        },
        changeMeses(mes) {
            const splitDate = this.date.split('-');
            this.date = `${splitDate[0]}-${mes}-${splitDate[2]}`;
            this.actualizarIndicadoresDocumentos(splitDate[2], mes, splitDate[0]);
            this.obtenerDias(mes);
        },
        changeAnios(anio) {
            const anioActual = moment(new Date()).format('YYYY');
            const splitDate = this.date.split('-');
            if (parseInt(anio, 10) === parseInt(anioActual, 10)) {
                this.meses = [];
                for (let i = 0; i <= parseInt(moment(new Date()).format('M'), 10); i++) {
                    this.meses.push(this.mesesTotales[i]);
                }
                this.obtenerDias(splitDate[1], anio);
            } else {
                this.meses = [];
                this.meses = this.mesesTotales;
                this.obtenerDias(splitDate[1], anio);
            }
            this.date = `${anio}-${splitDate[1]}-${splitDate[2]}`;
            this.actualizarIndicadoresDocumentos(splitDate[2], splitDate[1], anio);
            this.actualizarMontos(anio);
        },
        actualizarIndicadoresDocumentos(dia, mes, anio) {
            this.downloading = true;
            const enterpriseId = (this.taxpayer_id !== undefined && this.taxpayer_id !== null) ? this.taxpayer_id : this.user.enterprise_id;
            window.axios.get(`/api/enterprises/${enterpriseId}/${dia}/${mes}/${anio}/getStatistics`)
            .then((result) => {
                if (result.data.length >= 1) {
                    if (result.data[0].total != null) {
                      this.cant_documentos.facturas = this.noNumerico(result.data[0].invoices);
                      this.cant_documentos.credito = this.noNumerico(result.data[0].credit_notes);
                      this.cant_documentos.debito = this.noNumerico(result.data[0].debit_notes);
                      this.cant_documentos.guias = this.noNumerico(result.data[0].dispatch_guides);
                      this.cant_documentos.retenciones = this.noNumerico(result.data[0].retentions);
                      this.cant_documentos.islr = this.noNumerico(result.data[0].retentions_islr);
                      this.cant_documentos.total = this.noNumerico(result.data[0].total);
                      this.cant_documentos.anulados = this.noNumerico(result.data[0].annulment_events);
                      this.dataBarChart = [
                          ['Facturas', this.cant_documentos.facturas],
                          ['Notas de Crédito', this.cant_documentos.credito],
                          ['Notas de Débito', this.cant_documentos.debito],
                          ['Guías de Despacho', this.cant_documentos.guias],
                          ['Comprobantes de Retención IVA', this.cant_documentos.retenciones],
                          ['Comprobantes de Retención ISLR', this.cant_documentos.islr],
                          ['Anulados', this.cant_documentos.anulados],
                      ];
                    } else {
                        this.cant_documentos.facturas = 0;
                        this.cant_documentos.credito = 0;
                        this.cant_documentos.debito = 0;
                        this.cant_documentos.guias = 0;
                        this.cant_documentos.retenciones = 0;
                        this.cant_documentos.total = 0;
                        this.cant_documentos.anulados = 0;
                        this.dataBarChart = [
                            ['Facturas', 0],
                            ['Notas de Crédito', 0],
                            ['Notas de Débito', 0],
                            ['Guías de Despacho', 0],
                            ['Comprobantes de Retención IVA', 0],
                            ['Comprobantes de Retención ISLR', 0],
                            ['Anulados', 0],
                        ];
                    }
                } else {
                    this.dataBarChart = [
                            ['Facturas', 0],
                            ['Notas de Crédito', 0],
                            ['Notas de Débito', 0],
                            ['Guías de Despacho', 0],
                            ['Comprobantes de Retención IVA', 0],
                            ['Comprobantes de Retención ISLR', 0],
                            ['Anulados', 0],
                    ];
                }
                this.downloading = false;
            });
        },
        actualizarMontos(anio) {
            const enterpriseId = (this.taxpayer_id !== undefined && this.taxpayer_id !== null) ? this.taxpayer_id : this.user.enterprise_id;
            window.axios.get(`/api/enterprises/${enterpriseId}/${anio}/getStatisticsAmounts`)
              .then((result) => {
                const puntosSales = [
                    [`01/${anio}`, 0],
                    [`02/${anio}`, 0],
                    [`03/${anio}`, 0],
                    [`04/${anio}`, 0],
                    [`05/${anio}`, 0],
                    [`06/${anio}`, 0],
                    [`07/${anio}`, 0],
                    [`08/${anio}`, 0],
                    [`09/${anio}`, 0],
                    [`10/${anio}`, 0],
                    [`11/${anio}`, 0],
                    [`12/${anio}`, 0],
                ];
                const puntosTaxes = [
                    [`01/${anio}`, 0],
                    [`02/${anio}`, 0],
                    [`03/${anio}`, 0],
                    [`04/${anio}`, 0],
                    [`05/${anio}`, 0],
                    [`06/${anio}`, 0],
                    [`07/${anio}`, 0],
                    [`08/${anio}`, 0],
                    [`09/${anio}`, 0],
                    [`10/${anio}`, 0],
                    [`11/${anio}`, 0],
                    [`12/${anio}`, 0],
                ];
                const puntosTotal = [
                    [`01/${anio}`, 0],
                    [`02/${anio}`, 0],
                    [`03/${anio}`, 0],
                    [`04/${anio}`, 0],
                    [`05/${anio}`, 0],
                    [`06/${anio}`, 0],
                    [`07/${anio}`, 0],
                    [`08/${anio}`, 0],
                    [`09/${anio}`, 0],
                    [`10/${anio}`, 0],
                    [`11/${anio}`, 0],
                    [`12/${anio}`, 0],
                ];
                if (result.data.length > 0) {
                    for (let j = 0; j < result.data.length; j++) {
                        for (let i = 0; i < 12; i++) {
                            if (result.data[j] != null && parseInt(result.data[j].months, 10) === (i + 1)) {
                                puntosSales[i][1] = parseFloat(result.data[j].sales_amount);
                                puntosTaxes[i][1] = parseFloat(result.data[j].tax_amount);
                                puntosTotal[i][1] = parseFloat(result.data[j].total_amount);
                            }
                        }
                    }
                }
                this.dataLineChart = [
                    { name: 'Ventas', data: puntosSales },
                    { name: 'Impuestos', data: puntosTaxes },
                    { name: 'Total', data: puntosTotal },
                ];
            });
        },
        obtenerDias(item, anio = 0) {
            if (anio === 0) {
                anio = moment(new Date()).format('YYYY');
            }
            const anioActual = parseInt(moment(new Date()).format('YYYY'), 10);
            const mesActual = parseInt(moment(new Date()).format('M'), 10);
            const diaMes = moment(new Date()).format('D');
            const mes = parseInt(item, 10);
            if (mes === mesActual && parseInt(anio, 10) === anioActual) {
                this.dias = [];
                this.dias.push({ text: 'Todos', value: 'all' });
                for (let i = 1; i <= (diaMes - 1); i++) {
                    if (i < 10) {
                       i = `0${i.toString()}`;
                    }
                    this.dias.push({ text: i, value: i });
                }
            } else {
                switch (item) {
                    case 'all': {
                        this.dias = [];
                        this.dias.push({ text: 'Todos', value: 'all' });
                        break;
                    }
                    case '02': {
                        this.dias = [];
                        this.dias.push({ text: 'Todos', value: 'all' });
                        let dFeb = 28;
                        if ((anio % 4) === 0) {
                            dFeb = 29;
                        }
                        const diasMes = dFeb;
                        for (let i = 1; i <= diasMes; i++) {
                            if (i < 10) {
                                i = `0${i.toString()}`;
                            }
                            this.dias.push({ text: i, value: i });
                        }
                        break;
                    }
                    case '01':
                    case '03':
                    case '05':
                    case '07':
                    case '08':
                    case '10':
                    case '12':
                        this.dias = [];
                        this.dias.push({ text: 'Todos', value: 'all' });
                        for (let i = 1; i <= 31; i++) {
                            if (i < 10) {
                                i = `0${i.toString()}`;
                            }
                            this.dias.push({ text: i, value: i });
                        }
                        break;
                    default:
                        this.dias = [];
                        this.dias.push({ text: 'Todos', value: 'all' });
                        for (let i = 1; i <= 30; i++) {
                            if (i < 10) {
                                i = `0${i.toString()}`;
                            }
                            this.dias.push({ text: i, value: i });
                        }
                        break;
                }
            }
        },
        getIndicadores() {
          window.axios.get('/api/enterprises/getStatisticsGlobalsAdmin')
          .then((result) => {
              this.cant_usuarios.admin = result.data.cant_usuarios.admin;
              this.cant_usuarios.seniat = result.data.cant_usuarios.seniat;
              this.cant_usuarios.imprenta = result.data.cant_usuarios.imprenta;
              this.cant_numeraciones = result.data.cant_numeraciones;
              this.cant_lotes = result.data.cant_lotes;
              this.cant_empresas = result.data.cant_empresas;
          });
        },
        actualizar() {
          this.downloading = true;
          const splitDate = this.date.split('-');
          this.obtenerDias(splitDate[1], splitDate[0]);
          const enterpriseId = (this.taxpayer_id !== undefined && this.taxpayer_id !== null) ? this.taxpayer_id : this.user.enterprise_id;
          window.axios.get(`/api/enterprises/${enterpriseId}/${splitDate[2]}/${splitDate[1]}/${splitDate[0]}/getStatistics`)
          .then((result) => {
              this.cant_documentos.facturas = this.noNumerico(result.data[0].invoices);
              this.cant_documentos.credito = this.noNumerico(result.data[0].credit_notes);
              this.cant_documentos.debito = this.noNumerico(result.data[0].debit_notes);
              this.cant_documentos.guias = this.noNumerico(result.data[0].dispatch_guides);
              this.cant_documentos.retenciones = this.noNumerico(result.data[0].retentions);
              this.cant_documentos.retentiones_islr = this.noNumerico(result.data[0].retentions_islr);
              this.cant_documentos.total = this.noNumerico(result.data[0].total);
              this.cant_documentos.anulados = this.noNumerico(result.data[0].annulment_events);
              this.dataBarChart = [
                  ['Facturas', this.cant_documentos.facturas],
                  ['Notas de Crédito', this.cant_documentos.credito],
                  ['Notas de Débito', this.cant_documentos.debito],
                  ['Guías de Despacho', this.cant_documentos.guias],
                  ['Comprobantes de Retención IVA', this.cant_documentos.retenciones],
                  ['Comprobantes de Retención ISLR', this.cant_documentos.retentiones_islr],
                  ['Anulados', this.cant_documentos.anulados],
              ];
              this.downloading = false;
          });
          this.actualizarMontos(splitDate[0]);
        },
        noNumerico(number) {
          let result = 0;
          if (!Number.isNaN(parseFloat(number))) {
            result = parseFloat(number);
          }
          return result;
        },
    },
};
</script>
<style>
  .line-slim{
    line-height: 0.7rem;
  }
</style>
